import script from "./ordersummary.vue?vue&type=script&setup=true&lang=js"
export * from "./ordersummary.vue?vue&type=script&setup=true&lang=js"

import "./ordersummary.vue?vue&type=style&index=0&id=deda4874&lang=scss&scoped=scoped"

import exportComponent from "C:\\Users\\23586\\Desktop\\美国站\\h5\\us-station-number\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-deda4874"]])

export default __exports__